import { useLanguage } from "../context/LanguageContext";

export const UI_STRINGS = {
  it: {
    nav_services: "Servizi",
    nav_offers: "Consulenze",
    nav_contact: "Contattami",
    footer_tagline: "Consulenza AI per il business",
    footer_rights: "Tutti i diritti riservati.",
    footer_admin: "Area Admin",
    about_label: "Chi sono",
    about_chips: ["Metodo", "Misurabilità", "Zero hype"],
    services_label: "Cosa faccio",
    offers_label: "Quali consulenze offro",
    contact_label: "Contatti",
    form_name: "Nome",
    form_email: "Email",
    form_message: "Messaggio",
    form_name_ph: "Il tuo nome",
    form_email_ph: "nome@azienda.it",
    form_message_ph: "Raccontami il tuo progetto o la sfida che vuoi affrontare con l'AI...",
    form_send: "Invia richiesta",
    form_sending: "Invio in corso...",
    toast_ok: "Messaggio inviato! Ti risponderò entro 24 ore lavorative.",
    toast_err: "Invio non riuscito. Riprova o scrivimi direttamente via email.",
    family_kicker: "Progetto / Webapp",
    family_cta_embed: "Vedi l'app nel sito",
    family_url_missing: "Link all'app in configurazione",
    family_embed_overline: "App / Nel sito",
    family_embed_title: "Usa Family Expenses senza uscire da qui",
    family_placeholder_title: "L'app sarà incorporata qui",
    family_placeholder_text: "L'amministratore può collegare l'URL della webapp Family Expenses dal pannello admin, sezione \"Family Expenses\".",
    family_features: [
      { title: "Budget condivisi", text: "Un unico spazio per le spese di tutta la famiglia." },
      { title: "Categorie e report", text: "Capisci dove vanno i soldi con report mensili chiari." },
      { title: "Per tutta la famiglia", text: "Ogni membro contribuisce e tiene traccia delle proprie spese." },
    ],
    voice_suggestions: ["Che consulenze offri?", "Cos'è un AI Audit?", "Come posso contattare il consulente?"],
    voice_ph: "Scrivi una domanda sulle consulenze...",
    voice_unsupported: "Il tuo browser non supporta il riconoscimento vocale: puoi comunque scrivere qui sotto.",
    mic_unsupported_toast: "Il riconoscimento vocale non è supportato da questo browser. Usa la scrittura.",
    widget_title: "Assistente consulentIA.net",
    widget_ph: "Scrivi una domanda...",
    widget_suggestions: ["Che consulenze offri?", "Cos'è un AI Audit?", "Come posso contattarti?"],
    greeting: "Benvenuto, sei pronto a scoprire come migliorare l'efficienza della tua azienda? Scrivimi o parlami per condividere la tua idea, sarà un piacere darti supporto. Claudio",
    greeting_replay: "Riascolta",
  },
  en: {
    nav_services: "Services",
    nav_offers: "Consulting",
    nav_contact: "Contact me",
    footer_tagline: "AI consulting for business",
    footer_rights: "All rights reserved.",
    footer_admin: "Admin Area",
    about_label: "About me",
    about_chips: ["Method", "Measurability", "Zero hype"],
    services_label: "What I do",
    offers_label: "Consulting offers",
    contact_label: "Contact",
    form_name: "Name",
    form_email: "Email",
    form_message: "Message",
    form_name_ph: "Your name",
    form_email_ph: "name@company.com",
    form_message_ph: "Tell me about your project or the challenge you want to tackle with AI...",
    form_send: "Send request",
    form_sending: "Sending...",
    toast_ok: "Message sent! I'll reply within 24 business hours.",
    toast_err: "Sending failed. Try again or email me directly.",
    family_kicker: "Project / Web app",
    family_cta_embed: "See the app on this site",
    family_url_missing: "App link being configured",
    family_embed_overline: "App / On this site",
    family_embed_title: "Use Family Expenses without leaving this site",
    family_placeholder_title: "The app will be embedded here",
    family_placeholder_text: "The administrator can link the Family Expenses web app URL from the admin panel.",
    family_features: [
      { title: "Shared budgets", text: "One shared space for the whole family's spending." },
      { title: "Categories & reports", text: "See where the money goes with clear monthly reports." },
      { title: "For the whole family", text: "Every member contributes and tracks their own expenses." },
    ],
    voice_suggestions: ["What consulting do you offer?", "What is an AI Audit?", "How can I contact the consultant?"],
    voice_ph: "Type a question about the consulting services...",
    voice_unsupported: "Your browser doesn't support speech recognition: you can still type below.",
    mic_unsupported_toast: "Speech recognition is not supported by this browser. Please type instead.",
    widget_title: "consulentIA.net Assistant",
    widget_ph: "Type a question...",
    widget_suggestions: ["What consulting do you offer?", "What is an AI Audit?", "How can I contact you?"],
    greeting: "Welcome! Are you ready to discover how to improve your company's efficiency? Write to me or speak to me to share your idea, it will be a pleasure to support you. Claudio",
    greeting_replay: "Listen again",
  },
};

export const getLang = () => localStorage.getItem("site-lang") || "it";

export function useUI() {
  const { lang } = useLanguage();
  return UI_STRINGS[lang] || UI_STRINGS.it;
}
